import { Typography } from 'antd';
import type { CSSProperties } from 'react';

const { Text } = Typography;

interface CardEyebrowProps {
  label: string;
  /** Dot color. Omit to render the label without a dot. */
  color?: string;
  style?: CSSProperties;
}

/** Uppercase card eyebrow label with an optional colored dot. */
export function CardEyebrow({ label, color, style }: CardEyebrowProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
      {color && (
        <span
          aria-hidden
          style={{
            width: 6,
            height: 6,
            borderRadius: 3,
            backgroundColor: color,
            flexShrink: 0,
          }}
        />
      )}
      <Text
        type="secondary"
        style={{
          fontSize: 11,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          lineHeight: 1,
        }}
      >
        {label}
      </Text>
    </div>
  );
}
